/*!
VueLayers
Vue 2 components to work with OpenLayers

@package vuelayers
@author Vladimir Vershinin <ghettovoice@gmail.com>
@version 0.9.1
@license MIT
@copyright (c) 2017-2018, Vladimir Vershinin <ghettovoice@gmail.com>
*/
import TileLayer from 'ol/layer/tile';
import { layer } from '../core';

/**
 * @module tile-layer/layer
 */
/**
 * @vueProps
 */
var props = /** @lends module:tile-layer/layer# */{
  /**
   * Load low-resolution tiles up to `preload` levels.
   * @type {number}
   * @default 0
   */
  preload: {
    type: Number,
    default: 0
  }

  /**
   * @vueMethods
   */
};var methods = /** @lends module:tile-layer/layer# */{
  /**
   * @return {ol.layer.Tile}
   * @protected
   */
  createLayer: function createLayer() {
    return new TileLayer({
      id: this.id,
      minResolution: this.minResolution,
      maxResolution: this.maxResolution,
      opacity: this.opacity,
      visible: this.visible,
      preload: this.preload,
      extent: this.extent,
      zIndex: this.zIndex,
      source: this._source
    });
  }
};

/**
 * Layer that provide pre-rendered, tiled images in grid that are organized by zoom levels for
 * specific resolutions. `vl-tile-layer` component implements a **source container** interface, so it should be
 * used together with tile-like `vl-source-*` components.
 *
 * @title vl-layer-tile
 * @alias module:tile-layer/layer
 * @vueProto
 *
 * @vueSlot default Default slot for `vl-source-*` (tile-like only) components.
 */
var Layer = {
  name: 'vl-layer-tile',
  mixins: [layer],
  props: props,
  methods: methods
};

/**
 * @module tile-layer
 */
/**
 * @alias module:tile-layer
 *
 * @example Install
 * import Vue from 'vue'
 * // import module and styles
 * import { TileLayer } from 'vuelayers'
 * // or
 * import TileLayer from 'vuelayers/lib/tile-layer'
 * // import VueLayers styles
 * import 'vuelayers/lib/style.css'
 * // register components
 * Vue.use(TileLayer)
 */
var index = {
  /**
   * Layer that provide pre-rendered, tiled images in grid that are organized by zoom levels for
   * specific resolutions.
   * @alias module:tile-layer/layer
   */
  Layer: Layer,
  install: function install(Vue) {
    Vue.component(Layer.name, Layer);
  }
};

export default index;

//# sourceMappingURL=index.es.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/vuelayers/lib/tile-layer/index.es.js
// module id = null
// module chunks = 